import { render, staticRenderFns } from "./LoginDealRecharge.vue?vue&type=template&id=00fa10d4&scoped=true&"
import script from "./LoginDealRecharge.vue?vue&type=script&lang=js&"
export * from "./LoginDealRecharge.vue?vue&type=script&lang=js&"
import style0 from "./LoginDealRecharge.vue?vue&type=style&index=0&id=00fa10d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00fa10d4",
  null
  
)

export default component.exports